
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M15.495 9.455s.054-.465.054-.93c0-.466-.054-.931-.054-.931L13.808 7.2a5.413 5.413 0 0 0-.611-1.474l.915-1.472s-.291-.367-.62-.697c-.33-.329-.697-.62-.697-.62l-1.472.915a5.413 5.413 0 0 0-1.473-.61l-.395-1.688S8.99 1.5 8.525 1.5c-.466 0-.931.054-.931.054L7.2 3.241a5.413 5.413 0 0 0-1.474.611l-1.472-.914s-.367.29-.697.62c-.329.329-.62.696-.62.696l.915 1.472c-.271.453-.48.948-.61 1.474l-1.688.394s-.054.465-.054.93c0 .466.054.931.054.931l1.687.395c.132.525.34 1.02.611 1.473l-.914 1.472s.29.368.62.697c.329.329.696.62.696.62l1.472-.915c.453.272.948.48 1.474.61l.394 1.688s.465.054.93.054c.466 0 .931-.054.931-.054m-.141-5.148a1.745 1.745 0 0 1-2.283-2.11m3.396.783c-.02.107-.049.213-.088.316m-.6-2.035c.089.065.17.138.246.218M7.88 7.176c.096-.052.197-.095.302-.129","stroke-linecap":"round"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"m13.812 11.535-.484-1.308c-.225-.607-1.085-.607-1.31 0l-.483 1.308-1.308.484c-.607.224-.607 1.084 0 1.31l1.308.483.484 1.307c.224.608 1.084.608 1.31 0l.483-1.307 1.307-.484c.608-.225.608-1.085 0-1.31l-1.307-.483Z"}})])])
          )
        }
      }
    